import React from 'react';
import { useTranslation } from 'react-i18next';
import './RecordLabel.css';

function RecordLabel() {
  const { t } = useTranslation();

  const spotifyLabelUrl = "https://open.spotify.com/playlist/5fuU1YNAaMNutCWEzS7k0j?si=Ja5ox3lsTjSCTgtcBagCYQ&pi=zvyFkKo_S326D";

  return (
    <section className="record-label" id="record-label">
      <div className="container">
        <div className="section-header animate-fade-in-up">
          <h2>{t('recordLabel.title')}</h2>
          <p className="section-description">
            {t('recordLabel.description')}
          </p>
        </div>

        <div className="label-content">
          <div className="nft-showcase animate-fade-in-up">
            <div className="nft-visual">
              <div className="nft-cube">
                <div className="cube-face front">🎵</div>
                <div className="cube-face back">🎶</div>
                <div className="cube-face right">🎼</div>
                <div className="cube-face left">🎤</div>
                <div className="cube-face top">🎧</div>
                <div className="cube-face bottom">📀</div>
              </div>
              <div className="nft-glow"></div>
            </div>

            <div className="nft-info">
              <h3>High-Quality Music NFTs</h3>
              <p className="nft-quality">
                {t('recordLabel.nftDescription')}
              </p>
              <div className="quality-specs">
                <div className="spec-item">
                  <span className="spec-label">Bit Depth:</span>
                  <span className="spec-value">24-bit</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Sample Rate:</span>
                  <span className="spec-value">44.1 kHz</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Format:</span>
                  <span className="spec-value">NFT</span>
                </div>
              </div>
            </div>
          </div>

          <div className="label-features animate-fade-in-up">
            <div className="feature-grid">
              <div className="feature-item">
                <div className="feature-icon">🏷️</div>
                <h4>All Genres</h4>
                <p>From electronic to acoustic, we record everything</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">💎</div>
                <h4>Premium Quality</h4>
                <p>Studio-grade recordings in highest fidelity</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🌐</div>
                <h4>Blockchain Secured</h4>
                <p>Authentic ownership through NFT technology</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🎯</div>
                <h4>Exclusive Access</h4>
                <p>Limited edition releases for collectors</p>
              </div>
            </div>
          </div>

          <div className="spotify-label-section animate-fade-in-up">
            <h3>Our Label on Spotify</h3>
            <p>Discover our curated collection of releases</p>
            <a
              href={spotifyLabelUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary spotify-label-btn"
            >
              {t('recordLabel.discover')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default RecordLabel;